import { getVideoMediaRef, isVideoMedia } from '../Media/Media.utils'
import type { VideoFillLayerCSSVars, BackgroundMedia } from '@wix/thunderbolt-becky-types'

export const getVideoFillLayerCSSVars = (backgroundMedia: BackgroundMedia): VideoFillLayerCSSVars | undefined => {
	if (!isVideoMedia(backgroundMedia)) {
		return
	}

	// default to fully visible opacity for cases where inner component has no video opacity and container component
	// has video opacity because we don't want the child to inherit the parent opacity css variable value
	const videoMediaRef = getVideoMediaRef(backgroundMedia)
	const videoOpacity = videoMediaRef?.opacity

	return { '--fill-layer-video-opacity': videoOpacity ?? 1 }
}
